var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 14.6693H10.0002C13.3335 14.6693 14.6668 13.3359 14.6668 10.0026V6.0026C14.6668 2.66927 13.3335 1.33594 10.0002 1.33594H6.00016C2.66683 1.33594 1.3335 2.66927 1.3335 6.0026V10.0026C1.3335 13.3359 2.66683 14.6693 6.00016 14.6693Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2533 10.1782V5.05153C12.2533 4.5382 11.8399 4.16488 11.3333 4.20488H11.3066C10.4133 4.27821 9.05993 4.73822 8.29993 5.21155L8.2266 5.25822C8.1066 5.33155 7.8999 5.33155 7.77323 5.25822L7.66658 5.19155C6.91325 4.71822 5.55992 4.27154 4.66659 4.1982C4.15992 4.1582 3.74658 4.53822 3.74658 5.04488V10.1782C3.74658 10.5849 4.07991 10.9715 4.48657 11.0182L4.60657 11.0382C5.52657 11.1582 6.95327 11.6315 7.7666 12.0782L7.78658 12.0849C7.89991 12.1515 8.08657 12.1515 8.19324 12.0849C9.00657 11.6315 10.4399 11.1649 11.3666 11.0382L11.5066 11.0182C11.9199 10.9715 12.2533 10.5915 12.2533 10.1782Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.39844V11.7718",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.a90aef27b67335e203d92affc0289104.svg";
export { ForwardRef as ReactComponent };